<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Beállítás</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  Fejlesztés alatt
  <ion-segment value="0" [scrollable]="true">
    <ion-segment-button value="0">
      <ion-label>Nyilvántartás</ion-label>
      <ion-icon [name]="'archive'"></ion-icon>
    </ion-segment-button>
    <ion-segment-button value="1">
      <ion-label>Állomány</ion-label>
      <ion-icon [name]="'people'"></ion-icon>
    </ion-segment-button>
    <ion-segment-button value="2">
      <ion-label>Tanulók</ion-label>
      <ion-icon [name]="'people-circle'"></ion-icon>
    </ion-segment-button>
    <ion-segment-button value="3">
      <ion-label>Órarend</ion-label>
      <ion-icon [name]="'calendar'"></ion-icon>
    </ion-segment-button>
    <ion-segment-button value="4">
      <ion-label>Ttf</ion-label>
      <ion-icon [name]="'calendar'"></ion-icon>
    </ion-segment-button>
    <ion-segment-button value="5">
      <ion-label>Faliújság</ion-label>
      <ion-icon [name]="'newspaper'"></ion-icon>
    </ion-segment-button>
    <ion-segment-button value="5">
      <ion-label>Étkezés</ion-label>
      <ion-icon [name]="'restaurant'"></ion-icon>
    </ion-segment-button>
    <ion-segment-button value="5">
      <ion-label>Leltár</ion-label>
      <ion-icon [name]="'cube'"></ion-icon>
    </ion-segment-button>
    <ion-segment-button value="6">
      <ion-label>Szerződés</ion-label>
      <ion-icon [name]="'document-attach'"></ion-icon>
    </ion-segment-button>
    <ion-segment-button value="6">
      <ion-label>Számla</ion-label>
      <ion-icon [name]="'document'"></ion-icon>
    </ion-segment-button>
    <ion-segment-button value="7">
      <ion-label>Hibajelentés</ion-label>
      <ion-icon [name]="'bug'"></ion-icon>
    </ion-segment-button>
  </ion-segment>
  <!--ion-item>
    <ion-input label="Default Input" placeholder="Enter text"></ion-input>
  </ion-item>

  <ion-item>
    <ion-input
      label="Fixed Input"
      label-placement="fixed"
      placeholder="Enter text"
    ></ion-input>
  </ion-item>

  <ion-item>
    <ion-input
      label="Stacked Input"
      label-placement="stacked"
      placeholder="Enter text"
    ></ion-input>
  </ion-item>

  <ion-item>
    <ion-input
      label="Floating Input"
      label-placement="floating"
      placeholder="Enter text"
    ></ion-input>
  </ion-item-->
  <ion-card>
    <ion-card-header>
      <!--ion-card-title>Állománylista</ion-card-title-->
      <ion-row>
        <ion-col>
      <span style="font-size:25px;">Állománylista</span>
      <span style="float:right">
        <ion-button id="open-modal2" color="success"><fa-icon icon="cloud-arrow-up" slot="start"></fa-icon>&nbsp;Import</ion-button>
        <ion-button id="open-modal"><fa-icon icon="plus" slot="start"></fa-icon>&nbsp;Új</ion-button>
      </span>
        </ion-col>
      </ion-row>
    </ion-card-header>
    <ion-card-content *ngIf="allomany">
      <ngx-datatable
        class="ngx-datatable cronomit fixed-header fixed-row virtualized scroll-horz selectable checkbox-selection"
        [rows]="allomany"
        [columns]="columns"
        [sortType]="SortType.single"
        [columnMode]="ColumnMode.force"
        [limit]="10"
        [sorts]="[{ prop: 'viselt_vez', dir: 'asc' },{ prop: 'viselt_ker', dir: 'asc' }]"
      >
        <ngx-datatable-column name="Oktatási azonosító" prop="oktazon">
          <ng-template let-value="value" ngx-datatable-cell-template>
            <strong>{{ value }}</strong>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Név" prop="viselt_vez">
          <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
            {{ row.viselt_vez }} {{ row.viselt_ker }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Születési dátum" prop="szul_datum">
          <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
            {{ value | date:"yyyy. MM. dd." }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Munkakör" prop="munkakor">
          <ng-template let-value="value" ngx-datatable-cell-template>
            {{ value.split(",")[0] }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Jogviszony" prop="jogviszony_status">
          <ng-template let-value="value" ngx-datatable-cell-template>
            {{ value.split(",")[0] }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Műveletek">
          <ng-template let-value="value" ngx-datatable-cell-template>
            gomb
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </ion-card-content>
  </ion-card>

  <!--ion-item>
    <ion-toggle> Toggle </ion-toggle>
  </ion-item>

  <ion-item>
    <ion-checkbox> Checkbox </ion-checkbox>
  </ion-item>

  <ion-item>
    <ion-range label-placement="start">
      <div slot="label">Range</div>
    </ion-range>
  </ion-item-->
</ion-content>
